import { jsx as _jsx } from "react/jsx-runtime";
import { withConfigurationConsumer } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/configurableBrandTileUtils";
import { ShowroomTileBadge } from "@faire/retailer-visitor-shared/components/Showroom/ShowroomTileBadge";
import { TopShopTileBadge } from "@faire/retailer-visitor-shared/components/TopShop/TopShopTileBadge";
import { useTopShopVisibility } from "@faire/retailer-visitor-shared/components/TopShop/useTopShopVisibility";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var BrandTileBadgeBase = function(props) {
    var brand = props.tile.brand;
    var isTopShopContentVisibleForBrand = useTopShopVisibility(brand === null || brand === void 0 ? void 0 : brand.is_top_shop).isTopShopContentVisibleForBrand;
    var renderNonEventBadge = function() {
        if (brand === null || brand === void 0 ? void 0 : brand.is_showroom) {
            if (props.configuration.disableShowroom) {
                return null;
            }
            return /*#__PURE__*/ _jsx(StyledShowroomTileBadge, {
                token: brand === null || brand === void 0 ? void 0 : brand.token,
                customEventName: "brand-tile"
            });
        }
        if (isTopShopContentVisibleForBrand) {
            if (props.configuration.disableTopShop) {
                return null;
            }
            return /*#__PURE__*/ _jsx(StyledTopShopTileBadge, {});
        }
        return null;
    };
    return /*#__PURE__*/ _jsx(Wrapper, {
        children: renderNonEventBadge()
    });
};
export var BrandTileBadge = observer(withConfigurationConsumer(BrandTileBadgeBase));
var Wrapper = styled(Row).withConfig({
    componentId: "sc-2b9f84b5-0"
})([
    "position:absolute;top:",
    ";left:",
    ";z-index:3;"
], getSpacing("1x"), getSpacing("1x"));
var StyledTopShopTileBadge = styled(TopShopTileBadge).withConfig({
    componentId: "sc-2b9f84b5-1"
})([
    "opacity:1;transition:opacity 0.5s ease-in-out;position:relative;"
]);
var StyledShowroomTileBadge = styled(ShowroomTileBadge).withConfig({
    componentId: "sc-2b9f84b5-2"
})([
    "opacity:1;transition:opacity 0.5s ease-in-out;position:relative;"
]);
